export default __webpack_public_path__ + "static/m-portfolio4-a6a2e0a39462901ebf3027589ba50594.jpg";